export default __webpack_public_path__ + "static/media/drop-off-icon.1b72dce5.svg";